import { useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ReactGA from "react-ga4";
import ErrorPage from "./pages/ErrorPage/ErrorPage";
import Redirect from "./components/Redirect";
import ActivatingPage from "./pages/ActivatingPage/ActivatingPage";
import ActivatedPage from "./pages/ActivatedPage/ActivatedPage";
import UnsubscribePage from "./pages/UnsubscribePage/UnsubscribePage";

import UserInfoPage from "./pages/UserInfoPage/UserInfoPage";
import "./App.css";
import ActivationFormProvider from "./store/ActivationFormProvider";
import QueuePage from "./pages/QueuePage/QueuePage";

function App() {

  useEffect(() => {
    try {
      ReactGA.initialize("G-5F7QGXG61T", {
        testMode: true,
        gtagUrl: "https://www.googletagmanager.com/gtag/js?id=G-5F7QGXG61T",
        gtagOptions: {
          client_id: localStorage?.getItem("client_id"),
          user_id: localStorage?.getItem("session_id"),
        },
      });
    } catch (e) {
      if ((typeof e === "string" || typeof e === "object" || e instanceof String || e instanceof Error) && e) {
        try {
          console.error("Error initializing Google Analytics", e);
        } catch (e) {}
      }
    }
  }, []);
  const router = createBrowserRouter([
    {
      path: "/error",
      element: <ErrorPage />,
    },
    {
      path: "/activating",
      element: <ActivatingPage />,
    },
    {
      path: "/activated",
      element: <ActivatedPage />,
    },
    {
      path: "/in-queue",
      element: <QueuePage />,
    },
    {
      path: "/unsubscribe",
      element: <UnsubscribePage />,
    },
    {
      path: "/",
      element: (
        <ActivationFormProvider>
          <UserInfoPage />
        </ActivationFormProvider>
      ),
      errorElement: <Redirect />,
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;
